import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';
@Component({
  selector: 'app-beta',
  templateUrl: './beta.component.html',
  styleUrls: ['./beta.component.scss']
})
export class BetaComponent implements OnInit {

  why:any="";
  error=false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }


  ngOnInit(): void {

  }

  cancelBeta(){
    this.error = false;

    if(this.why == ""){

      this.error = true;

    }else{

      this.okService.put("account/beta",{beta:false,why:this.why})
      .subscribe((data:any) => {
  
        //console.log(data.body);
  
        let url = data.body['url'];
  
        //console.log(url);
  
        window.location.href = url;
  
      });
    }

  }

}
